var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-form-stacked"},[_c('form-select',{ref:"select",attrs:{"label":_vm.$t('rubinred.ecommerce.orders.checkout.bank'),"validations":['required'],"value":_vm.value,"values":_vm.values}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a9b9524","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/payment/GestpayMybankHandler.vue
// module id = F++g
// module chunks = 0